import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import { TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery, BreakPoints } from '../helpers/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var horizontalPadding = Spacings.s32;
var horizontalPaddingSmall = Spacings.s16;
var checkoutTitle = {
  fontWeight: FontWeights.bold,
  fontSize: FontSizes.s20,
  color: TextColors.base,
  lineHeight: 1.4,
  display: 'flex',
  gap: Spacings.s12,
  alignItems: 'center',
  marginBottom: Spacings.s16
};
var hiddenScrollbars = {
  scrollbarWidth: 'none',
  /* Firefox */
  MsOverflowStyle: 'none',
  /* IE and Edge */
  /* Hide scrollbar for Chrome, Safari and Opera */
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};
var browserAutocompleteBackground = function browserAutocompleteBackground(bgColor, textColor) {
  return {
    '& input, & select, & textarea': {
      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus': {
        WebkitBoxShadow: "0 0 0 1000px ".concat(bgColor, " inset !important"),
        WebkitTextFillColor: "".concat(textColor, " !important")
      }
    }
  };
};
var checkoutLabel = {
  fontWeight: FontWeights.semibold,
  fontSize: FontSizes.s14,
  lineHeight: 1.4,
  marginBottom: Spacings.s8,
  color: TextColors.tint1
};
var stepperContent = _defineProperty({
  paddingLeft: horizontalPadding,
  paddingRight: horizontalPadding
}, mediaQuery(BreakPoints.Small), {
  paddingLeft: horizontalPaddingSmall,
  paddingRight: horizontalPaddingSmall
});
var checkoutButton = {
  display: 'flex',
  width: '100%',
  justifyContent: 'center'
};
var checkoutButtonBack = {
  marginRight: Spacings.s8,
  flexShrink: 0
};
var checkoutStepperProgress = {
  margin: [-12, Spacings.s0, Spacings.s12, -6]
};
var checkoutFooter = {
  display: 'flex',
  alignItems: 'center',
  paddingTop: Spacings.s16
};
var checkoutContainer = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  paddingBottom: Spacings.s16
};

// TODO: refactor needed for paddings
var checkoutVerticalPaddings = _defineProperty({
  paddingTop: Spacings.s40,
  paddingBottom: Spacings.s0
}, mediaQuery(BreakPoints.Small), {
  paddingTop: Spacings.s48
});
var checkoutContent = {
  overflow: 'auto',
  flexGrow: 1
};
var checkoutDescription = {
  fontSize: FontSizes.s16,
  fontWeight: FontWeights.semibold,
  color: TextColors.tint1,
  lineHeight: 1.5,
  marginBottom: Spacings.s24
};
var textMedium16 = {
  fontSize: FontSizes.s16,
  fontWeight: FontWeights.medium,
  color: TextColors.tint1,
  lineHeight: 1.5
};
var checkoutBenefits = _objectSpread(_objectSpread({}, textMedium16), {}, {
  marginBottom: Spacings.s16
});
var defaultOutline = {
  outline: '-webkit-focus-ring-color auto 2px',
  outlineOffset: 2,
  fallbacks: {
    outline: 'Highlight auto 2px'
  }
};

export { browserAutocompleteBackground, checkoutBenefits, checkoutButton, checkoutButtonBack, checkoutContainer, checkoutContent, checkoutDescription, checkoutFooter, checkoutLabel, checkoutStepperProgress, checkoutTitle, checkoutVerticalPaddings, defaultOutline, hiddenScrollbars, horizontalPadding, horizontalPaddingSmall, stepperContent, textMedium16 };
//# sourceMappingURL=index.js.map
